module.exports = __webpack_public_path__ + "img/ed002-login.34cd4efa.png";